module.exports = __webpack_public_path__ + "static/gallery-68b9ec20dae3cc651228b75c91624ac8.png";